import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public enablePersonasManagement = environment.features.enablePersonasManagement;
  public enableSystemPrompts = environment.features.enableSystemPrompts;

  ngOnInit(): void {
    console.log('Init from admin component');
  }
}
